/* eslint-disable no-extend-native */

export default function overload() {
  Date.prototype.utc = function () {
    return new Date(this.getTime() + this.getTimezoneOffset() * 60000);
  }
}
